
export default [
  {
    "title": "Disposable inbound mailboxes",
    "summary": "Instantly generate private, disposable inboxes with automatic expiration. Effortlessly avoid spam, manage sign-ups, and report abuse—with robust inbound email processing and transparent public stats. Your address is ready as soon as you visit the homepage.",
    "date": new Date("2026-05-03T00:00:00.000Z"),
    "version": "0.1.0",
    "type": "feature",
    "content": "",
    "_meta": {
      "filePath": "v0.1.0/disposable-inbound.md",
      "fileName": "disposable-inbound.md",
      "directory": "v0.1.0",
      "extension": "md",
      "path": "v0.1.0/disposable-inbound"
    },
    "html": ""
  }
]